export default __webpack_public_path__ + "static/media/rw.23704412.svg";